import Vue from 'vue';

export const auth = Vue.observable({account: null});
const api = process.env.VUE_APP_API_URL;

export async function authRequest(path, data) {
    const response = await fetch(`${api}/auth${path}`, {
        method: data === undefined ? 'GET' : 'POST',
        credentials: 'include',
        headers: {'Content-Type': 'application/json', 'X-Pokeland-Request': '1'},
        ...(data === undefined ? {} : {body: JSON.stringify(data)})
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.error || 'Action impossible.');
    return result;
}

export async function loadAccount() {
    auth.account = (await authRequest('/me')).account;
    return auth.account;
}

function decode(value) {
    const encoded = value.replace(/-/g, '+').replace(/_/g, '/');
    return Uint8Array.from(atob(encoded + '='.repeat((4 - encoded.length % 4) % 4)), c => c.charCodeAt(0));
}

function encode(buffer) {
    return btoa(String.fromCharCode(...new Uint8Array(buffer)))
        .replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

function serialize(credential) {
    const response = {};
    ['clientDataJSON', 'attestationObject', 'authenticatorData', 'signature', 'userHandle'].forEach(key => {
        if (credential.response[key]) response[key] = encode(credential.response[key]);
    });
    if (credential.response.getTransports) response.transports = credential.response.getTransports();
    return {
        id: credential.id, rawId: encode(credential.rawId), type: credential.type, response,
        clientExtensionResults: credential.getClientExtensionResults()
    };
}

export async function usePasskey(register = false) {
    if (!window.isSecureContext || !window.PublicKeyCredential) {
        throw new Error('Utilisez un navigateur compatible et l’adresse HTTPS du site.');
    }
    try {
        const path = register ? '/enrollment' : '/login';
        const options = await authRequest(`${path}/options`, {});
        options.challenge = decode(options.challenge);
        if (options.user) options.user.id = decode(options.user.id);
        ['excludeCredentials', 'allowCredentials'].forEach(key => {
            if (options[key]) options[key] = options[key].map(item => ({...item, id: decode(item.id)}));
        });
        const credential = register
            ? await navigator.credentials.create({publicKey: options})
            : await navigator.credentials.get({publicKey: options});
        await authRequest(`${path}/verify`, serialize(credential));
        await loadAccount();
    } catch (error) {
        if (error.name === 'NotAllowedError') {
            throw new Error('Validation annulée ou délai dépassé. Vous pouvez réessayer.');
        }
        throw error;
    }
}

export async function logout() {
    await authRequest('/logout', {});
    auth.account = null;
    // Clear all cached customer views and any in-memory application data.
    window.location.assign('/login');
}
